import {
	LoyaltyProgramMemberDTO,
	FindLoyaltyMemberRequest,
	FindLoyaltyMemberResponse,
	PaymentDTO,
	CheckRequiredCustomerResultDTO,
	CheckRequiredCustomerForTicketsRequest,
	CheckRequiredCustomerForTicketsResponse,
	OrderedItemsStateDTO,
	GetOrderedItemsStateRequest,
	GetOrderedItemsStateResponse,
	MoveTicketRequest,
	MoveTicketResponse,
	TicketDTO,
	TicketLocationDTO,
	GetExistingTicketsInLocationRequest,
	GetExistingTicketsInLocationResponse,
	TicketSummaryDTO,
	GetOpenedTicketsRequest,
	GetOpenedTicketsResponse,
	GetTicketByIdRequest,
	GetTicketByIdResponse,
	BuyerCustomerDTO,
	SetBuyerCustomerRequest,
	CloseTicketFromPosRequest,
	CloseTicketFromPosResponse,
	InvoiceParamsFromPosDTO,
	SaleDTO,
	PrepareTicketRequest,
	PrepareTicketLineRequest,
	ServiceChargeDTO,
	SetTicketServiceChargeRequest,
	GetTicketServiceChargeRequest,
	GetTicketServiceChargeResponse,
	TipDTO,
	GetTicketTipRequest,
	GetTicketTipResponse,
	SetTicketTipRequest,
	TicketLineDTO,
	AvailableUserDTO,
	SetTicketLineCreatorRequest,
	InviteTicketLineRequest,
	ChangeTicketOpenerUserRequest,
	AddTicketLoyaltyInfoRequest,
	RewardDTO,
	RemoveTicketLoyaltyInfoRequest,
	SetTicketNamedDiscountRequest,
	SetTicketDiscountsRequest,
	SetTicketPriceListRequest,
	SetTicketFriendlyNameRequest,
	OfferInListDTO,
	SetTicketOffersRequest,
	CancellationType,
	CancelTicketRequest,
	SetTicketLineCashDiscountRequest,
	SetTicketLineDiscountPercentageRequest,
	SetTicketLineDiscountsRequest,
	SetTicketLineNamedDiscountRequest,
	RequestOrderedLineRequest,
	AddTicketLineNoteRequest,
	AddTicketLineRequest,
	AddTicketLineResponse,
	CancelPrintedTicketLineRequest,
	CancelTicketLineRequest,
	ChangeTicketLineAddinsRequest,
	CompleteMenuRequest,
	CompleteMenuResponse,
	CourseDTO,
	CreateNewOrGetUnusedTicketInLocationRequest,
	CreateNewOrGetUnusedTicketInLocationResponse,
	CreateNewTicketForLocationRequest,
	CreateNewTicketForLocationResponse,
	GetCoursesToPrepareRequest,
	GetCoursesToPrepareResponse,
	PreparationOrderDTO,
	PrepareTicketAgainRequest,
	PrepareTicketLineAgainRequest,
	RefundTicketFromPosRequest,
	RefundTicketFromPosResponse,
	ReleaseTicketRequest,
	RemovePrintedTicketLineRequest,
	RemoveTicketLineRequest,
	RequestOrderedItemsRequest,
	SetTableCompanionsRequest,
	SetTicketLinePreparationOrderRequest,
	SetTicketLinePriceRequest,
	SetTicketLineQuantityRequest,
	ShouldAskBeforeNotifyQuantityChangedRequest,
	ShouldAskBeforeNotifyQuantityChangedResponse,
	ShouldTicketBeCancelledOrDeletedRequest,
	ShouldTicketBeCancelledOrDeletedResponse,
	SoldProductDTO,
	StartTakeOutOrderParamsDTO,
	StartTakeOutOrderRequest,
	StartTakeOutOrderResponse,
	AddDeliveryPersonBalanceDeltaRequest,
	ReleaseTicketResponse,
	AddTicketPaymentsRequest,
	AddTicketPaymentsResponse,
	NamedDiscountProposalDTO,
	GetNamedDiscountProposalRequest,
	GetNamedDiscountProposalResponse,
	RemovedIngredientDTO,
	AdjustTicketLineIngredientsRequest,
	ReleaseScaleTicketRequest,
	ScaleTicketDTO,
	SetMinTicketAmountRequest,
	SetTicketLineSeatNumberRequest,
	BlockTicketByPosRequest,
	UnblockTicketByPosRequest,
	GetTicketPaymentRequest,
	GetTicketPaymentResponse,
	FinishPendingCardTransactionRequest,
	RegisterPendingCardTransactionRequest,
	RegisterPendingCardTransactionResponse,
	ProcessPendingCardTransactionsRequest,
	ProcessPendingCardTransactionsResponse,
	PendingCardTransactionsStatusDTO
} from 'core/api';

import { Bus } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export async function searchMember(memberId: string): Promise<LoyaltyProgramMemberDTO> {
	const request = new FindLoyaltyMemberRequest({ memberId });
	return await process(request, (response: FindLoyaltyMemberResponse) => response.LoyaltyMember);
}

export async function checkRequiredCustomerForTickets(ticketIds: number[], payments: PaymentDTO[]): Promise<CheckRequiredCustomerResultDTO> {
	const request = new CheckRequiredCustomerForTicketsRequest({ ticketIds, newPayments: payments });
	return await process(request, (response: CheckRequiredCustomerForTicketsResponse) => response.Result);
}

export async function getOrderedItemsState(ticketIds: number[]): Promise<OrderedItemsStateDTO[]> {
	const request = new GetOrderedItemsStateRequest({ ticketIds: ticketIds });
	return await process(request, (response: GetOrderedItemsStateResponse) => response.OrdersState);
}

export async function moveTicket(ticket: TicketDTO, keepPrices: boolean, location: TicketLocationDTO): Promise<TicketDTO> {
	const request = new MoveTicketRequest({ sourceTicketId: ticket.Id, keepPrices, targetLocation: location, targetTicketId: null });
	return await process(request, (response: MoveTicketResponse) => response.Ticket);
}

export async function joinTicket(ticket: TicketDTO, keepPrices: boolean, location: TicketLocationDTO, targetTicketId: number): Promise<TicketDTO> {
	const request = new MoveTicketRequest({ sourceTicketId: ticket.Id, keepPrices, targetLocation: location, targetTicketId: targetTicketId });
	return await process(request, (response: MoveTicketResponse) => response.Ticket);
}

export async function getExistingTicketsIn(saleCenterId: number, saleLocationName: string): Promise<TicketSummaryDTO[]> {
	const request = new GetExistingTicketsInLocationRequest({ saleCenterId, saleLocationName });
	return await process(request, (response: GetExistingTicketsInLocationResponse) => response.Tickets);
}

export async function getOpenedTickets(): Promise<TicketSummaryDTO[]> {
	const request = new GetOpenedTicketsRequest();
	return await process(request, (response: GetOpenedTicketsResponse) => response.Tickets);
}

export async function getTicket(ticketId: number, claimTicket = false): Promise<TicketDTO> {
	const request = new GetTicketByIdRequest({ ticketId, claimTicket });
	return await process(request, (response: GetTicketByIdResponse) => response.Ticket);
}

export async function getPayment(ticketId: number, documentPaymentId: number): Promise<PaymentDTO> {
	const request = new GetTicketPaymentRequest({ ticketId, documentPaymentId });
	return await process(request, (response: GetTicketPaymentResponse) => response.Payment);
}


export async function setBuyerCustomer(ticketId: number, customer: BuyerCustomerDTO): Promise<void> {
	const request = new SetBuyerCustomerRequest({ ticketId, customer });
	return await process<void>(request);
}

export async function closeTicket(ticketId: number, params: InvoiceParamsFromPosDTO): Promise<SaleDTO> {
	const request = new CloseTicketFromPosRequest({ ticketId, params });
	return await process(request, (response: CloseTicketFromPosResponse) => response.Sale);
}

export async function prepareTickets(ticketIds: number[], isAutoPrepare: boolean): Promise<void> {
	const request = new PrepareTicketRequest({ ticketIds, isAutoPrepare });
	await process(request);
}

export async function prepareLine(ticketId: number, lineId: number): Promise<void> {
	const request = new PrepareTicketLineRequest({ ticketId, lineId });
	await process(request);
}

export async function setServiceCharge(ticketId: number, serviceCharge: ServiceChargeDTO): Promise<void> {
	const request = new SetTicketServiceChargeRequest({ ticketId, chargePercentage: serviceCharge.Percentage, applyTo: serviceCharge.ApplyTo, chargeTax: serviceCharge.Vat, ignoreTicketDiscounts: serviceCharge.IgnoreTicketDiscounts });
	return await process(request);
}

export async function getServiceCharge(ticketId: number): Promise<ServiceChargeDTO> {
	const request = new GetTicketServiceChargeRequest({ ticketId });
	return await process(request, (response: GetTicketServiceChargeResponse) => response.ServiceCharge);
}

export async function getTipSettings(ticketId: number): Promise<TipDTO> {
	const request = new GetTicketTipRequest({ ticketId });
	return await process(request, (response: GetTicketTipResponse) => response.Tip);
}

export async function setTipSettings(ticketId: number, ticketTip: TipDTO): Promise<void> {
	const request = new SetTicketTipRequest({ ticketId, applyTo: ticketTip.ApplyTo, ignoreTicketDiscounts: ticketTip.IgnoreTicketDiscounts, tipPercentage: ticketTip.TipPercentage, tipTax: ticketTip.TipTax });
	return await process(request);
}

export async function changeTicketOpenerUser(ticketId: number, user: AvailableUserDTO): Promise<void> {
	const request = new ChangeTicketOpenerUserRequest({ ticketId, userId: user.Id });
	return await process(request);
}

export async function inviteLine(ticketId: number, ticketLineId: number): Promise<void> {
	const request = new InviteTicketLineRequest({ ticketId, ticketLineId });
	return await process(request);
}

export async function setTicketLineCreator(ticketId: number, ticketLine: TicketLineDTO, user: AvailableUserDTO): Promise<void> {
	const request = new SetTicketLineCreatorRequest({ ticketId, ticketLineId: ticketLine.Id, creatorId: user.Id });
	return await process(request);
}

export async function addPayments(ticketId: number, payments: PaymentDTO[], prepayAmount: number): Promise<SaleDTO> {
	const request = new AddTicketPaymentsRequest({ ticketId, payments, prepayAmount });
	return await process(request, (response: AddTicketPaymentsResponse) => response.Sale);
}

export async function addLoyaltyInfo(ticketId: number, memberId: string, rewards: RewardDTO[]): Promise<void> {
	const request = new AddTicketLoyaltyInfoRequest({ ticketId, memberId, rewards });
	return await process(request);
}

export async function removeLoyaltyInfo(ticketId: number): Promise<void> {
	const request = new RemoveTicketLoyaltyInfoRequest({ ticketId });
	return await process(request);
}

export async function setTicketNamedDiscount(ticketId: number, discountId: number, authorizerId: Nullable<number>): Promise<void> {
	const request = new SetTicketNamedDiscountRequest({ ticketId, discountId, authorizerId });
	return await process(request);
}

export async function setTicketDiscounts(ticketId: number, cashDiscount: number, discountPercentage: number): Promise<void> {
	const request = new SetTicketDiscountsRequest({ ticketId, cashDiscount, discountPercentage });
	return await process(request);
}

export async function setTicketPriceList(ticketId: number, priceListId: Nullable<number>): Promise<void> {
	const request = new SetTicketPriceListRequest({ ticketId, priceListId });
	return await process(request);
}

export async function setFriendlyName(ticketId: number, name: string): Promise<void> {
	const request = new SetTicketFriendlyNameRequest({ ticketId, name });
	await process(request);
}

export async function setOffers(ticketId: number, offers: OfferInListDTO[]): Promise<void> {
	const request = new SetTicketOffersRequest({ ticketId, offers });
	await process(request);
}

export async function cancelTicket(ticketId: number, type: CancellationType, reason: string): Promise<void> {
	const request = new CancelTicketRequest({ ticketId, reason, type });
	await process(request);
}

export async function setLineCashDiscount(ticketId: number, ticketLineId: number, discount: number): Promise<void> {
	const request = new SetTicketLineCashDiscountRequest({ ticketId, ticketLineId, discount });
	await process(request);
}

export async function setLineDiscountPercentage(ticketId: number, ticketLineId: number, percentage: number): Promise<void> {
	const request = new SetTicketLineDiscountPercentageRequest({ ticketId, ticketLineId, percentage });
	await process(request);
}

export async function setLineDiscounts(ticketId: number, ticketLineId: number, cashDiscount: number, discountPercentage: number): Promise<void> {
	const request = new SetTicketLineDiscountsRequest({ ticketId, ticketLineId, cashDiscount, discountPercentage });
	await process(request);
}

export async function setLineNamedDiscount(ticketId: number, ticketLineId: number, discountId: number, authorizerId: Nullable<number>): Promise<void> {
	const request = new SetTicketLineNamedDiscountRequest({ ticketId, ticketLineId, discountId, authorizerId });
	await process(request);
}

export async function requestLine(ticketId: number, lineId: number): Promise<void> {
	const request = new RequestOrderedLineRequest({ ticketId, lineId });
	await process(request);
}

export async function prepareAgain(ticketIds: number[]): Promise<void> {
	const request = new PrepareTicketAgainRequest({ ticketIds });
	await process(request);
}

export async function prepareLineAgain(ticketId: number, lineId: number): Promise<void> {
	const request = new PrepareTicketLineAgainRequest({ ticketId, lineId });
	await process(request);
}

export async function requestCourses(ticketIds: number[], preparationOrderId: number): Promise<void> {
	const request = new RequestOrderedItemsRequest({ ticketIds, preparationOrderId });
	await process(request);
}

export async function getCoursesToPrepare(ticketIds: number[]): Promise<CourseDTO[]> {
	const request = new GetCoursesToPrepareRequest({ ticketIds });
	return await process(request, (response: GetCoursesToPrepareResponse) => response.Courses);
}

export async function createNewTicket(location: TicketLocationDTO): Promise<TicketDTO> {
	const request = new CreateNewTicketForLocationRequest({ location });
	return await process(request, (response: CreateNewTicketForLocationResponse) => response.Ticket);
}

export async function refundTicket(ticketId: number, params: InvoiceParamsFromPosDTO): Promise<SaleDTO> {
	const request = new RefundTicketFromPosRequest({ ticketId, params, isInvoicePartialRefund: false });
	return await process(request, (response: RefundTicketFromPosResponse) => response.Sale);
}

export async function createNewOrGetUnusedTicket(location: TicketLocationDTO): Promise<TicketDTO> {
	const request = new CreateNewOrGetUnusedTicketInLocationRequest({ location });
	return await process(request, (response: CreateNewOrGetUnusedTicketInLocationResponse) => response.Ticket);
}

export async function completeMenu(ticketId: number): Promise<TicketDTO> {
	const request = new CompleteMenuRequest({ ticketId });
	return await process(request, (response: CompleteMenuResponse) => response.Ticket);
}

export async function startTakeOutOrder(location: TicketLocationDTO, params: StartTakeOutOrderParamsDTO): Promise<TicketDTO> {
	const request = new StartTakeOutOrderRequest({ params, location });
	return await process(request, (response: StartTakeOutOrderResponse) => response.Ticket);
}

export async function checkRequiredCustomer(ticketIds: number[], payments: PaymentDTO[]): Promise<CheckRequiredCustomerResultDTO> {
	const request = new CheckRequiredCustomerForTicketsRequest({ ticketIds, newPayments: payments });
	return await process(request, (response: CheckRequiredCustomerForTicketsResponse) => response.Result);
}

export async function setTableCompanions(ticketId: number, tableCompanions: Nullable<number>): Promise<void> {
	const request = new SetTableCompanionsRequest({ ticketId, tableCompanions });
	await await process(request);
}

export async function releaseTicket(ticketId: number, releasedByCurrentUser: boolean): Promise<boolean> {
	const request = new ReleaseTicketRequest({ ticketId, releasedByCurrentUser });
	return await process(request, (response: ReleaseTicketResponse) => response.HasBeenDeletedOrCancelled);
}

export async function shouldBeCancelledOrDeleted(ticketId: number): Promise<boolean> {
	const request = new ShouldTicketBeCancelledOrDeletedRequest({ ticketId });
	return await process(request, (response: ShouldTicketBeCancelledOrDeletedResponse) => response.Should);
}

export type AddTicketLineParams = {
	product: SoldProductDTO,
	addins: SoldProductDTO[],
	quantity: number,
	preparationNotes: string,
	ownerId: Nullable<number>,
	couponCode: string,
	removedIngredients: RemovedIngredientDTO[],
	seatNumber: Nullable<number>
}

export async function addLine(ticketId: number, params: AddTicketLineParams): Promise<AddTicketLineResponse> {
	const request = new AddTicketLineRequest({
		ticketId,
		ownerId: params.ownerId,
		product: params.product,
		addins: params.addins,
		quantity: params.quantity,
		preparationNotes: params.preparationNotes,
		couponCode: params.couponCode,
		removedIngredients: params.removedIngredients,
		seatNumber: params.seatNumber
	});

	return await process(request, async (response: AddTicketLineResponse) => response);
}

export async function removeLine(ticketId: number, line: TicketLineDTO): Promise<void> {
	const request = new RemoveTicketLineRequest({ ticketId, ticketLineId: line.Id });
	await process(request);
}

export async function removePrintedLine(ticketId: number, line: TicketLineDTO, reason: string): Promise<void> {
	const request = new RemovePrintedTicketLineRequest({ ticketId, ticketLineId: line.Id, reason });
	await process(request);
}

export async function cancelLine(ticketId: number, line: TicketLineDTO, reason: string): Promise<void> {
	const request = new CancelTicketLineRequest({ ticketId, ticketLineId: line.Id, reason });
	await process(request);
}

export async function cancelPrintedLine(ticketId: number, line: TicketLineDTO, reason: string): Promise<void> {
	const request = new CancelPrintedTicketLineRequest({ ticketId, ticketLineId: line.Id, reason });
	await process(request);
}

export async function changeLineAddins(ticketId: number, lineId: number, addins: SoldProductDTO[]): Promise<void> {
	const request = new ChangeTicketLineAddinsRequest({ ticketId, ticketLineId: lineId, addins });
	await process(request);
}

export async function adjustLineIngredients(ticketId: number, ticketLineId: number, removedIngredients: RemovedIngredientDTO[]): Promise<void> {
	const request = new AdjustTicketLineIngredientsRequest({ ticketId, ticketLineId, removedIngredients });
	await process(request);
}

export async function addLineNote(ticketId: number, line: TicketLineDTO, notes: string): Promise<void> {
	const request = new AddTicketLineNoteRequest({ ticketId, ticketLineId: line.Id, note: notes });
	await process(request);
}

export async function setLinePreparationOrder(ticketId: number, line: TicketLineDTO, preparationOrder: PreparationOrderDTO): Promise<void> {
	const request = new SetTicketLinePreparationOrderRequest({ ticketId, ticketLineId: line.Id, preparationOrderId: preparationOrder.Id });
	await process(request);
}

export async function shouldAskBeforeNotifyQuantityChanged(ticketId: number, line: TicketLineDTO): Promise<boolean> {
	const request = new ShouldAskBeforeNotifyQuantityChangedRequest({ ticketId, ticketLineId: line.Id });
	return await process(request, (response: ShouldAskBeforeNotifyQuantityChangedResponse) => response.ShouldAsk);
}

export async function setLineQuantity(ticketId: number, line: TicketLineDTO, quantity: number, notifyKitchenPrinters: boolean): Promise<void> {
	const request = new SetTicketLineQuantityRequest({ ticketId, ticketLineId: line.Id, quantity: quantity, ticketLineStatus: line.Status, notifyKitchenPrinters });
	await process(request);
}

export async function setLineSeatNumber(ticketId: number, line: TicketLineDTO, seatNumber: Nullable<number>): Promise<void> {
	const request = new SetTicketLineSeatNumberRequest({ ticketId, ticketLineId: line.Id, seatNumber });
	await process(request);
}

export async function setLinePrice(ticketId: number, line: TicketLineDTO, price: number): Promise<void> {
	const request = new SetTicketLinePriceRequest({ ticketId, ticketLineId: line.Id, price });
	await process(request);
}

export async function addDeliveryPersonBalanceDelta(deliveryPersonId: number, delta: number, reason: string) {
	const request = new AddDeliveryPersonBalanceDeltaRequest({ deliveryPersonId, delta, reason });
	await process(request);
}

export async function getNamedDiscountProposal(discountId: number, ticketId: number, lineId: Nullable<number>): Promise<NamedDiscountProposalDTO> {
	const request = new GetNamedDiscountProposalRequest({ discountId, ticketId, lineId });
	return await process(request, (response: GetNamedDiscountProposalResponse) => response.Proposal);
}

export async function relaseScaleTicket(ticketId: number, ticket: ScaleTicketDTO): Promise<void> {
	const request = new ReleaseScaleTicketRequest({ ticketId, scale: ticket.Scale, scaleTicketNumber: ticket.Ticket });
	await process(request);
}

export async function setMinAmount(ticketId: number, minAmount: number): Promise<void> {
	const request = new SetMinTicketAmountRequest({ ticketId, minAmount });
	await process(request);
}

export async function blockTicketByPos(ticketId: number): Promise<void> {
	const request = new BlockTicketByPosRequest({ ticketId });
	await process(request);
}

export async function unblockTicketByPos(ticketId: number, audit: boolean): Promise<void> {
	const request = new UnblockTicketByPosRequest({ ticketId, audit });
	await process(request);
}

export async function registerPendingCardTransaction(ticketGlobalId: Nullable<string>, amount: number, cardTransactionType: string): Promise<string> {
	const request = new RegisterPendingCardTransactionRequest({ ticketGlobalId, amount, cardTransactionType });
	return await process(request, (response: RegisterPendingCardTransactionResponse) => response.TransactionId);
}

export async function finishPendingCardTransaction(ticketGlobalId: Nullable<string>, transactionId: string, amount: number, transactionType: string, xmlDetails: string): Promise<void> {
	const request = new FinishPendingCardTransactionRequest({ ticketGlobalId, transactionId, amount, transactionType, xmlDetails });
	await process(request);
}

export async function processPendingCardTransactionStatus(ticketId: number): Promise<PendingCardTransactionsStatusDTO[]> {
	const request = new ProcessPendingCardTransactionsRequest({ ticketId });
	return await process(request, (response: ProcessPendingCardTransactionsResponse) => response.TransactionsStatus);
}